import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import HeaderContent from '../HeaderContent';
import { CheckboxField } from 'Shared/form/CheckboxField';
import { CheckboxMultiField } from 'Shared/form/CheckboxMultiField';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';
import ExcludeToggleFilter from './ExcludeToggleFilter';

const TherapeuticCategoryMultiSelectFilter = () => {
    const {
        values: { filterParams, allCategoriesList },
        setFieldValue,
    } = useFormikContext();
    const { allCategories, categories, excludeCategories } = filterParams;
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);

    const isExcludeDisabled =
        allCategories || !categories.length || categories.length === (allCategoriesList || []).length;

    useEffect(() => {
        if (isExcludeDisabled && excludeCategories) {
            setFieldValue('filterParams.excludeCategories', false);
        }
    }, [isExcludeDisabled, excludeCategories, setFieldValue]);

    return (
        <AccordionWrapper
            title="Therapeutic Category"
            stateKey="workQueueTCFilter-toggle"
            HeaderContent={HeaderContent}
            headerClassName="accordion-header-h4-title"
        >
            <div className="multi-select-spacing-filter">
                <ExcludeToggleFilter
                    fieldName="filterParams.excludeCategories"
                    disabled={isExcludeDisabled}
                    onChange={(checked) => setWorkQueueFilter(filterParams, 'excludeCategories', checked, true)}
                />
                <CheckboxField
                    fieldName="filterParams.allCategories"
                    className="spacing-leading-checkbox"
                    label="All Therapeutic Categories"
                    onChange={(e) =>
                        setWorkQueueFilter(
                            {
                                ...filterParams,
                                categories: e.target.checked ? [] : categories,
                                excludeCategories: e.target.checked ? false : excludeCategories,
                            },
                            'allCategories',
                            e.target.checked,
                            true
                        )
                    }
                />
                {!allCategories && (
                    <CheckboxMultiField
                        fieldName="filterParams.categories"
                        className="spacing-multi-checkboxes"
                        value={categories}
                        options={allCategoriesList}
                        onChange={(value) => setWorkQueueFilter(filterParams, 'categories', value, true)}
                    />
                )}
            </div>
        </AccordionWrapper>
    );
};

export default TherapeuticCategoryMultiSelectFilter;
